import Geocode, { Attributes } from 'types/Geocode';

export default class Base implements Geocode {
  locationData: Attributes;

  constructor(locationData: Attributes) {
    this.locationData = locationData;
  }

  get city(): string {
    return this.locationData.city;
  }

  get stateAbbreviation(): string {
    return this.locationData.stateAbbreviation;
  }

  get latitude(): number {
    return this.locationData.latitude;
  }

  get longitude(): number {
    return this.locationData.longitude;
  }

  get zip(): string {
    return this.locationData.zip;
  }

  toJSON(): Attributes {
    return {
      city: this.city,
      stateAbbreviation: this.stateAbbreviation,
      latitude: this.latitude,
      longitude: this.longitude,
      zip: this.zip,
    };
  }
}
